/**
 * Kontingent-Anzeige (Tenant Edition, Post #4713) — Verbrauchsbalken mit drei
 * Zuständen: ok / warn (≥80 %) / throttled. Erscheint NUR auf Instanzen, die
 * den Usage-Vertrag erfüllen (useTenantUsage ist selbst-gatend); auf der
 * Betreiber-Föderation rendert sie nichts.
 *
 * Drossel-UX (Vertragskern): `throttled` wird VOR dem Absenden erklärt —
 * ein benannter Zustand mit Reset-Datum, kein stummer Fehler danach.
 * Dieselbe Klasse wie die needs_login-Blocking-States.
 */
import { useTenantUsage, usageLevel, usagePercent } from '../hooks/useTenantUsage';
import './UsageMeter.css';

function fmtReset(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('de-AT', { day: 'numeric', month: 'long' });
}

export function UsageMeter() {
  const usage = useTenantUsage();
  if (!usage) return null;
  const level = usageLevel(usage);
  const pct = usagePercent(usage);
  const reset = fmtReset(usage.resets_at);
  return (
    <div className={`usage-meter usage-${level}`} title={`${usage.used_units.toLocaleString('de-AT')} von ${usage.included_units.toLocaleString('de-AT')} Einheiten verbraucht`}>
      <div className="usage-meter-bar" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="usage-meter-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="usage-meter-label">
        {level === 'throttled'
          ? <>Kontingent aufgebraucht{reset && <> — neu ab {reset}</>}</>
          : <>{pct} % Kontingent{reset && level === 'warn' && <> · Reset {reset}</>}</>}
      </span>
    </div>
  );
}
